<template>
  <v-dialog
    v-bind="mergedAttrs"
    :fullscreen="mergedAttrs.fullscreen !== undefined ? mergedAttrs.fullscreen : xs"
    :content-class="mergedAttrs.overflowVisible ? 'ovf-visible' : ''"
    data-test="sm-dialog"
  >
    <template #activator="slotProps">
      <slot
        name="activator"
        v-bind="slotProps"
      />
    </template>
    <slot />
  </v-dialog>
</template>

<script lang="ts">
import {
  computed,
  defineComponent
} from 'vue'
import { useDisplay } from 'vuetify'

export default defineComponent({
  name: 'SMDialog',
  // Don't automatically apply arguments to the root element of this component. We take care of merging them first and then apply them explicitly.
  // See https://vuejs.org/guide/components/attrs.html#disabling-attribute-inheritance
  inheritAttrs: false,
  setup(props, { attrs }) {
    const { xs } = useDisplay()
    const mergedAttrs = computed(() => ({
      'overlay-color': '#000000',
      'overlay-opacity': 0.38,
      'retain-focus': false,
      width: 640,
      scrollable: true,
      ...attrs
    }))
    return { mergedAttrs, xs }
  }
})
</script>

<style lang="scss" scoped>
:deep(.ovf-visible) {
  overflow-y: visible !important;
}
</style>
